/** @jsx builderX.jsx */
import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='paytableAssets'>
    <Sprite name='rubyFeature'>
        <Image src='ruby_balance'/>
        <Image src='ruby_total_bet_en'/>
        <Image src='ruby_coin_276x198'/>
    </Sprite>
</Sprite>;
